import { styled } from 'canoe';
import React, { FunctionComponent, ReactNode } from 'react';

import Box from './Box';

const Container = styled(Box)<{ dark: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding-left: 8px;
`;

export const Label = styled.div<{ smallLabel: boolean }>`
  flex-grow: 1;
  flex-basis: 0;
  height: 20px;
  overflow: hidden;

  ${({ smallLabel }) => (smallLabel ? 'max-width: fit-content; padding-right: 8px;' : '')}
`;

interface Props {
  label?: string | ReactNode;
  id?: string;
  dark?: boolean;
  light?: boolean;
  smallLabel?: boolean;
  radiusBottom?: boolean;
  children?: ReactNode;
  className?: string;
  'data-cy'?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const ValueBox: FunctionComponent<Props> = ({
  id,
  label,
  dark,
  light,
  children,
  className,
  'data-cy': dataCy,
  smallLabel,
  onClick,
  onMouseEnter,
  onMouseLeave,
  radiusBottom,
}: Props) => (
  <Container
    id={id}
    dark={!!dark}
    light={!!light}
    radiusBottom={radiusBottom}
    className={className}
    onClick={onClick}
    data-cy={dataCy}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {label && <Label smallLabel={!!smallLabel}>{label}</Label>}
    {children}
  </Container>
);

export default ValueBox;
